import Buttons from '../../../../../components/Buttons';
import { formatCash } from '../../../../../utils/tableHelpers';
import { IWalletDetailsCard } from './WalletDetailsCard.types';

import RefreshIcon from '../../../../../svgs/RefreshIcon';

import styles from './WalletDetailsCard.module.scss';

const WalletDetailsCard = ({
  walletAmount,
  handleWalletRefresh, isLoading,
}: IWalletDetailsCard) => (
  <div className={styles?.wrapper}>
    <div className={styles?.wrapper__card}>
      <section className={styles?.wrapper__texts}>
        <p className={styles?.wrapper__description}>Total Amount in Wallet</p>
        <h4 className={styles?.wrapper__amount}>
          {`$ ${isLoading ? '-' : formatCash(walletAmount)}`}
        </h4>
      </section>
      <Buttons
        name={`${isLoading ? 'Refreshing' : 'Refresh'}`}
        onClick={() => {
          handleWalletRefresh?.();
        }}
        className={styles?.wrapper__btn}
        Icon={!isLoading && RefreshIcon}
        btnIconStroke="black"
        disabled={isLoading}
      />
    </div>
  </div>
);

export default WalletDetailsCard;
